exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".live-completed {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n  color: #666;\n  text-align: center;\n  pointer-events: none;\n}\n.live-completed.live-completed--deleted {\n  color: #A0A0A0;\n}\n", ""]);

